import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';

export type ValidateFormType = {
  token: FormControl<string>
}

@Component({
    selector: 'app-step-verify-registration',
    templateUrl: './step-verify-registration.component.html',
    styleUrls: ['./step-verify-registration.component.scss'],
    imports: [AppErrorMessagesComponent, TranslateModule, ReactiveFormsModule]
})
export class StepVerifyRegistrationComponent implements OnInit {
  @Input() loading: boolean;
  @Output() next = new EventEmitter<FormGroup<ValidateFormType>>();
  @Output() back = new EventEmitter<void>();

  public validateForm: FormGroup<ValidateFormType>;
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initializeForm();
  }

  public validateRegistration(): void {
    if (this.validateForm.invalid || this.loading) {
      return;
    }
    this.next.emit(this.validateForm);
  }

  public goBack(): void {
    this.back.emit();
  }

  private initializeForm(): void {
    this.validateForm = this.fb.group<ValidateFormType>({
      token: this.fb.control<string>(null, Validators.required)
    });
  }
}
